// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_hc-0";
export var headerCellHover = "_hc-1";
export var readCellContainer = "_hc-2";
export var searchHighlight = "_hc-4";
export var unreadIndicator = "_hc-3";